'use strict';

export default class Gallery {
	constructor() {
        (function($){
            if($('.image-gallery').length > 0){

                $('.simple-ajax-popup').magnificPopup({
                    type: 'ajax',
                    gallery: {
                        enabled: true
                    },
                    closeOnContentClick: false,
                    removalDelay: 300
                });

                $(document).delegate('a.next','click',function(e){
                    $('.mfp-arrow.mfp-arrow-right.mfp-prevent-close').click();
                    e.preventDefault;
                }).delegate('a.prev','click',function(e){
                    $('.mfp-arrow.mfp-arrow-left.mfp-prevent-close').click();
                    e.preventDefault;
                })
            }
        })(jQuery);
    }
}